import { render, staticRenderFns } from "./ModifyProfile.vue?vue&type=template&id=a2fe139e"
import script from "./ModifyProfile.vue?vue&type=script&lang=js"
export * from "./ModifyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports